import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { prop } from '@ipfabric/utils/fp/prop';
import { TableBulkActions } from 'components/Table/components/TableBulkActions';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { deselectAllTableRows } from 'components/Table/model/commands/deselectAllTableRows';
import { cnBase } from 'tailwind-variants';

type Props = {
  borderless?: boolean;
};

export const TableTitleSelection = (props: Props) => {
  const ctxProps = useTableContextSelectors({
    hasBulkActions: (s) => (s.bulkActions?.length ?? 0) > 0,
    dispatch: prop('dispatch'),
    selectedCount: prop('selectedRows', 'size'),
  });
  return (
    <div
      className={cnBase(
        'flex flex-row items-center gap px py-sm h-16 bg-brand text-contrast',
        !props.borderless && 'rounded-t-lg',
      )}
    >
      <div className='text-base font-semibold flex flex-row items-center gap-3xs'>
        {ctxProps.selectedCount} selected
        <Icon
          className='cursor-pointer'
          glyph='fa-xmark'
          onClick={() => {
            ctxProps.dispatch(deselectAllTableRows);
          }}
        />
      </div>
      <div className='flex flex-row gap-xs'>
        {ctxProps.hasBulkActions && <TableBulkActions />}
      </div>
    </div>
  );
};
